import {
  Autocomplete,
  Button,
  Grid,
  TextField,
  FormLabel,
  FormControlLabel,
  RadioGroup,
  Radio,
} from "@mui/material";
import React from "react";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import Checkbox from "@mui/material/Checkbox";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

interface Props {
  setLoading: any;
  devices: any;
  device: any;
  setDevice: any;
  selectedStartDate: any;
  setSelectedStartDate: any;
  selectedEndDate: any;
  setSelectedEndDate: any;
  showDashboard: any;
  setShowDashboard: any;
  selectedSiteUid: any;
  selectedGraphType: any;
  setSelectedGraphType: any;
  exequteQueryContentQuery7: any;
  exequteQueryContentQuery8: any;
  selectedCompetitorCompany: any;
  setSelectedCompetitorCompany: any;
  selectedCompetitorDomainName: any;
  setSelectedCompetitorDomainName: any;
  display: any;
  show: any;
  setShow: any;
  setDisplay: any;
}

const CompetitorsPageSpeedDashboardFilter = ({
  devices,
  device,
  setDevice,
  selectedStartDate,
  setSelectedStartDate,
  selectedEndDate,
  setSelectedEndDate,
  selectedGraphType,
  selectedCompetitorDomainName,
  setSelectedCompetitorDomainName,
  exequteQueryContentQuery8,
  setSelectedGraphType,
  selectedCompetitorCompany,
  setSelectedCompetitorCompany,
  setDisplay,
  show,
  setShow,
}: Props) => {
  const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
  const checkedIcon = <CheckBoxIcon fontSize="small" />;

  const CompatitorCompanyNames = exequteQueryContentQuery8?.query_output?.map(
    (competitor: any) => {
      return { label: competitor?.competitor_company_name };
    }
  );

  const CompanyDomainNames = exequteQueryContentQuery8?.query_output?.map(
    (competitor: any) => {
      return { label: competitor?.competitor_domain };
    }
  );

  const uniqueCompatitorCompanyNames = Array.from(
    new Set(CompatitorCompanyNames?.map((item: any) => item?.label))
  )?.map((label) => {
    return CompatitorCompanyNames?.find((item: any) => item?.label === label);
  });

  const uniqueCompatitorDomainNames = Array.from(
    new Set(CompanyDomainNames?.map((item: any) => item?.label))
  )?.map((label) => {
    return CompanyDomainNames?.find((item: any) => item?.label === label);
  });

  const handleShow = () => {
    setSelectedCompetitorCompany([...uniqueCompatitorCompanyNames]);
    setSelectedCompetitorDomainName([...uniqueCompatitorDomainNames]);
    setShow(true);
    setDisplay(true);
  };

  React.useEffect(() => {
    if (show) {
      setSelectedCompetitorCompany([...uniqueCompatitorCompanyNames]);
      setSelectedCompetitorDomainName([...uniqueCompatitorDomainNames]);
      setDisplay(true);
    }
  }, [
    show,
    uniqueCompatitorCompanyNames,
    uniqueCompatitorDomainNames,
    setSelectedCompetitorCompany,
    setDisplay,
    setSelectedCompetitorDomainName,
  ]);

  const handleGraphTypeChange = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const newValue = event.target.value;
    setSelectedGraphType(newValue);
    // setSelectedCompetitorCompany([...uniqueCompatitorCompanyNames]);
    // setSelectedCompetitorDomainName([...uniqueCompatitorDomainNames]);
  };

  // Helper function to handle Select All for domains
  const handleDomainSelectAll = () => {
    if (selectedCompetitorDomainName.length === uniqueCompatitorDomainNames.length) {
      // If all are selected, deselect all
      setSelectedCompetitorDomainName([]);
    } else {
      // Select all
      setSelectedCompetitorDomainName([...uniqueCompatitorDomainNames]);
    }
  };

  // Helper function to handle Select All for companies
  const handleCompanySelectAll = () => {
    if (selectedCompetitorCompany.length === uniqueCompatitorCompanyNames.length) {
      // If all are selected, deselect all
      setSelectedCompetitorCompany([]);
    } else {
      // Select all
      setSelectedCompetitorCompany([...uniqueCompatitorCompanyNames]);
    }
  };

  // Get available options for domains (excluding selected ones)
  const availableDomainOptions = uniqueCompatitorDomainNames?.filter(
    (option) =>
      !selectedCompetitorDomainName.some(
        (selected: any) => selected.label === option.label
      )
  ) || [];

  // Get available options for companies (excluding selected ones)
  const availableCompanyOptions = uniqueCompatitorCompanyNames?.filter(
    (option) =>
      !selectedCompetitorCompany.some(
        (selected: any) => selected.label === option.label
      )
  ) || [];

  // Create options array with Select All option for domains
  const domainOptionsWithSelectAll = [
    {
      label: selectedCompetitorDomainName.length === uniqueCompatitorDomainNames.length 
        ? "Deselect All" 
        : "Select All",
      isSelectAll: true
    },
    ...availableDomainOptions
  ];

  // Create options array with Select All option for companies
  const companyOptionsWithSelectAll = [
    {
      label: selectedCompetitorCompany.length === uniqueCompatitorCompanyNames.length 
        ? "Deselect All" 
        : "Select All",
      isSelectAll: true
    },
    ...availableCompanyOptions
  ];

  return (
    <>
      <Grid container spacing={2} alignItems="center" sx={{ my: 1 }}>
        <Grid item xs={4}>
          {selectedGraphType === "individually" ? (
            <Autocomplete
              multiple
              fullWidth
              size="small"
              color="secondary"
              options={domainOptionsWithSelectAll}
              getOptionLabel={(option: any) => option.label}
              disabled={uniqueCompatitorDomainNames?.length === 0}
              value={selectedCompetitorDomainName}
              disableCloseOnSelect
              onChange={(_, newValue: any) => {
                // Check if Select All was clicked
                const selectAllClicked = newValue.find((item: any) => item.isSelectAll);
                if (selectAllClicked) {
                  handleDomainSelectAll();
                } else {
                  setSelectedCompetitorDomainName(newValue);
                }
              }}
              renderOption={(props, option) => {
                const key = option.label;
                const isSelectAll = option.isSelectAll;
                if (isSelectAll) {
                  return (
                    <li {...props} key={key} style={{ fontWeight: 'bold', borderBottom: '1px solid #e0e0e0' }}>
                      <Checkbox
                        icon={icon}
                        checkedIcon={checkedIcon}
                        style={{ marginRight: 8 }}
                        checked={selectedCompetitorDomainName.length === uniqueCompatitorDomainNames.length}
                        indeterminate={
                          selectedCompetitorDomainName.length > 0 && 
                          selectedCompetitorDomainName.length < uniqueCompatitorDomainNames.length
                        }
                        color="secondary"
                      />
                      {option.label}
                    </li>
                  );
                }
                return (
                  <li {...props} key={key}>
                    <Checkbox
                      icon={icon}
                      checkedIcon={checkedIcon}
                      style={{ marginRight: 8 }}
                      checked={false} // Always false since these are unselected options
                      color="secondary"
                    />
                    {option.label}
                  </li>
                );
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Competitor Domains"
                  fullWidth
                  color="secondary"
                  placeholder="Search Domain or choose from the list"
                  sx={{ whiteSpace: "nowrap" }}
                />
              )}
            />
          ) : (
            <Autocomplete
              multiple
              fullWidth
              size="small"
              color="secondary"
              options={companyOptionsWithSelectAll}
              getOptionLabel={(option: any) => option.label}
              value={selectedCompetitorCompany}
              disableCloseOnSelect
              onChange={(_, newValue: any) => {
                // Check if Select All was clicked
                const selectAllClicked = newValue.find((item: any) => item.isSelectAll);
                if (selectAllClicked) {
                  handleCompanySelectAll();
                } else {
                  setSelectedCompetitorCompany(newValue);
                }
              }}
              disabled={uniqueCompatitorCompanyNames?.length === 0}
              renderOption={(props, option) => {
                const key = option.label;
                const isSelectAll = option.isSelectAll;
                if (isSelectAll) {
                  return (
                    <li {...props} key={key} style={{ fontWeight: 'bold', borderBottom: '1px solid #e0e0e0' }}>
                      <Checkbox
                        icon={icon}
                        checkedIcon={checkedIcon}
                        style={{ marginRight: 8 }}
                        checked={selectedCompetitorCompany.length === uniqueCompatitorCompanyNames.length}
                        indeterminate={
                          selectedCompetitorCompany.length > 0 && 
                          selectedCompetitorCompany.length < uniqueCompatitorCompanyNames.length
                        }
                        color="secondary"
                      />
                      {option.label}
                    </li>
                  );
                }
                return (
                  <li {...props} key={key}>
                    <Checkbox
                      icon={icon}
                      checkedIcon={checkedIcon}
                      style={{ marginRight: 8 }}
                      checked={false} // Always false since these are unselected options
                      color="secondary"
                    />
                    {option.label}
                  </li>
                );
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Competitor Company Name"
                  fullWidth
                  color="secondary"
                  placeholder="Search Competitor or choose from the list"
                  sx={{ whiteSpace: "nowrap" }}
                />
              )}
            />
          )}
        </Grid>
        <Grid item xs={2}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DemoContainer components={["DatePicker"]} sx={{ pt: 0 }}>
              <DatePicker
                className="brandDataDatePicker"
                slotProps={{
                  textField: {
                    fullWidth: true,
                    size: "small",
                    color: "secondary",
                    required: true,
                    InputLabelProps: { shrink: true }, // Forces label to stay visible
                    sx: {
                      "& .MuiInputLabel-root": {
                        top: "7px", // Adjust the vertical position of the label if needed
                        fontSize: "0.9rem", // Optional: Adjust font size
                      },
                      "& .MuiInputBase-root": {
                        height: "40px", // Ensures sufficient height for small text field
                      },
                      minWidth: "100% !important",
                    },
                  },
                }}
                // sx={{ width: "100%" , minWidth: "100%" }}
                label="Start Date"
                value={selectedStartDate}
                onChange={(newValue: any) => {
                  if (newValue && newValue.isValid()) {
                    setSelectedStartDate(newValue); // Keep it as a dayjs object
                  }
                }}
                format="DD-MM-YYYY"
              />
            </DemoContainer>
          </LocalizationProvider>
        </Grid>
        <Grid item xs={2}>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <DemoContainer components={["DatePicker"]} sx={{ pt: 0 }}>
              <DatePicker
                slotProps={{
                  textField: {
                    fullWidth: true,
                    size: "small",
                    color: "secondary",
                    required: true,
                    InputLabelProps: { shrink: true }, // Forces label to stay visible
                    sx: {
                      "& .MuiInputLabel-root": {
                        top: "7px", // Adjust the vertical position of the label if needed
                        fontSize: "0.9rem", // Optional: Adjust font size
                      },
                      "& .MuiInputBase-root": {
                        height: "40px", // Ensures sufficient height for small text field
                      },
                      minWidth: "100% !important",
                    },
                  },
                }}
                label="End Date"
                value={selectedEndDate}
                onChange={(newValue: any) => {
                  if (newValue && newValue.isValid()) {
                    setSelectedEndDate(newValue); // Keep it as a dayjs object
                  }
                }}
                format="DD-MM-YYYY" // Set the display format
              />
            </DemoContainer>
          </LocalizationProvider>
        </Grid>
        <Grid item xs={2}>
          <Autocomplete
            fullWidth
            options={devices}
            getOptionLabel={(option: any) => option?.label}
            value={device}
            onChange={(_, newValue: any) => {
              setDevice(newValue);
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                label="Device"
                placeholder="Select a Device "
                InputProps={{
                  ...params.InputProps,
                }}
                color="secondary"
              />
            )}
            size="small"
          />
        </Grid>
        <Grid item xs={2} textAlign={"right"}>
          <Button
            data-tracker="198"
            variant="contained"
            color="secondary"
            onClick={handleShow}
            disabled={!selectedStartDate || !selectedEndDate || !device}
          >
            Compare
          </Button>
        </Grid>
        <Grid item xs={12}>
          <RadioGroup
            row
            sx={{ alignItems: "center" }}
            aria-label="graphType"
            value={selectedGraphType}
            onChange={handleGraphTypeChange}
            name="radio-buttons-group"
          >
            <FormLabel id="demo-row-radio-buttons-group-label" sx={{ mr: 2 }}>
              Display settings:
            </FormLabel>
            <FormControlLabel
              value="competitor"
              control={<Radio size="small" color="secondary" />}
              checked={selectedGraphType === "competitor"}
              label="Group sites by competitor"
            />
            <FormControlLabel
              value="individually"
              control={<Radio size="small" color="secondary" />}
              checked={selectedGraphType === "individually"}
              label="Show every site individually"
            />
          </RadioGroup>
        </Grid>
      </Grid>
    </>
  );
};

export default CompetitorsPageSpeedDashboardFilter;
